<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled}" @click="openModal" style="width: 55px;">
            {{ car.docs_received ? formatDate(car.docs_received) : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Auction docs</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <article v-if="error.status" class="message is-danger">
                        <div class="message-body">
                            <strong>{{ error.message }}!</strong>
                        </div>
                    </article>
                    <article v-if="success" class="message is-success">
                        <div class="message-body">
                            <strong>Success!</strong> File was uploaded!
                        </div>
                    </article>
                    <div class="field">
                        <datetime
                                input-class="input"
                                v-model="carData.query.docs_received"
                                :format="{ month: 'numeric', day: 'numeric'}"
                                type="date"
                                value-zone="local"
                                zone="local"
                                @close="selectDate"
                                :input-id="carData.id.toString()"
                                placeholder="Select date"
                        ></datetime>
                    </div>
                    <div class="field">
                        <div class="file has-name is-boxed">
                            <label class="file-label">
                                <input class="file-input" ref="file" v-on:change="handleFileUpload()" type="file">
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                  </span>
                                  <span class="file-label">
                                    Choose a file…
                                  </span>
                                </span>
                                <span class="file-name">
                                  {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                    <button class="button is-primary"  @click="uploadDocuments">Save</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                success: false,
                documents: '',
                fileName: 'Only PDF file.',
                error: {
                    status: false,
                    message: []
                },
                carData:{
                    id: this.car.id,
                    query: {
                        docs_received: this.car.docs_received,
                    }
                }
            }
        },
        methods: {
            selectDate() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.docs_received = this.carData.query.docs_received
                    })
                    .catch(error => console.log(error))
            },
            handleFileUpload(){
                this.documents = this.$refs.file.files[0];
                this.fileName = this.$refs.file.files[0].name;
            },
            uploadDocuments() {
                this.success = false
                let formData = new FormData();

                formData.append('documents', this.documents);
                formData.append('car_id',  this.car.id);

                apiCars
                    .carsUploadDocumentsRequest(formData)
                    .then((response) => {
                        this.success = true
                        this.fileName = 'Only PDF file.'
                        this.isActive = false
                    })
                    .catch(error => {
                        console.log(error)
                        if ( error.response && error.response.status === 422 ) {
                            this.error.status = true
                            this.error.message = 'The documents must be a file of type: pdf.'
                        }
                    })
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            openModal() {
                this.success = false
                this.isActive = !this.isActive
            }

        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.docs_received) !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/DocsRecivedColumn.vue